import { useEffect } from 'react';
import { getTranslationForLang, stringsTranslate } from '../locales/CustomTranslater';
import { appWords } from '../config/Constants';
import 'klaro/dist/klaro-no-css';
import ReactPixel from 'react-facebook-pixel';
import TiktokPixel from 'tiktok-pixel';
import ReactGA from 'react-ga4';
import { useSelector } from 'react-redux';

export default function KlaroLoader() {
    const appLanguageRS = useSelector((state) => state.appLanguageRS);

    const pixelId = process.env.REACT_APP_META_PIXEL_ID;
    const tiktokPixelId = process.env.REACT_APP_TIKTOK_PIXEL_ID;
    const gaIdCom = process.env.REACT_APP_GA4_ID_COM;
    const gaIdNl = process.env.REACT_APP_GA4_ID_NL;
    const currentDomain = window.location.hostname;

    const klaroConfig = {
        version: 1,
        elementID: 'klaro',
        storageMethod: 'cookie',
        cookieName: 'klaro',
        privacyPolicy: '/privacy',
        acceptAll: true,
        lang: appLanguageRS === 'be'? 'nl': appLanguageRS,

        translations: {
            en: {
                consentModal: {
                    title: getTranslationForLang('privacy_settings', 'en'),
                    description: getTranslationForLang('here_you_can_see_and_customize', 'en'),
                },
                purposes: {
                    merged: getTranslationForLang('essential_analytics', 'en'),
                    marketing: 'Marketing',
                },
                services: {
                    'site-core': {
                        title: 'Core Cookies',
                        description: getTranslationForLang('required_for_site_functionality', 'en'),
                    },
                    'site-marketing': {
                        title: 'Marketing Cookies',
                        description: getTranslationForLang('used_for_marketing', 'en'),
                    },
                },
            },
            nl: {
                consentModal: {
                    title: getTranslationForLang('privacy_settings', 'nl'),
                    description: getTranslationForLang('here_you_can_see_and_customize', 'nl'),
                },
                purposes: {
                    merged: getTranslationForLang('essential_analytics', 'nl'),
                    marketing: 'Marketing',
                },
                services: {
                    'site-core': {
                        title: 'Noodzakelijke cookies',
                        description: getTranslationForLang('required_for_site_functionality', 'nl'),
                    },
                    'site-marketing': {
                        title: 'Marketingcookies',
                        description: getTranslationForLang('used_for_marketing', 'nl'),
                    },
                },
            },

        },

        uiPurposeOrder: ['merged', 'marketing'],

        services: [
            {
                name: 'site-core',
                title: 'Core Cookies',
                description: stringsTranslate(appWords.required_for_site_functionality),
                purposes: ['merged'],
                cookies: [/^_ga/, /^_gid/, /^_gat/, /^__fb/, /^__session/],
                required: true,
                default: true,
                onlyOnce: true,
                callback: (consent) => {
                    if (consent) {
                        const gaId = currentDomain.includes('.nl') ? gaIdNl : gaIdCom;
                        ReactGA.initialize(gaId);
                    }
                },
            },
            {
                name: 'site-marketing',
                title: 'Marketing Cookies',
                description: stringsTranslate(appWords.used_for_marketing),
                purposes: ['marketing'],
                cookies: [/^_fbp/, /^fr/],
                required: false,
                default: true,
                callback: (consent) => {
                    if (consent) {
                        ReactPixel.init(pixelId);
                        ReactPixel.pageView();
                        TiktokPixel.init(tiktokPixelId);
                        TiktokPixel.pageView();
                    }
                },
            },
        ],
    };

    useEffect(() => {
        window.klaroConfig = klaroConfig;

        if (window.klaro && window.klaro.manager) {
            window.klaro.manager.changeLanguage(appLanguageRS); // <- updates without reinitializing
        } else {
            const script = document.createElement('script');
            script.src = 'https://cdn.kiprotect.com/klaro/v0.7.0/klaro.js';
            script.async = true;
            // script.onload = () => window.klaro.setup(klaroConfig);
            document.body.appendChild(script);
        }
    }, [appLanguageRS]);


    return null;
}
